export default __webpack_public_path__ + "static/media/1909.9c1c68e9.png";